import React from 'react';
import PropTypes from 'prop-types';
import { gql, graphql } from 'react-apollo';
import { Link } from 'react-router-dom';

const UpcomingTripsQuery = gql`
query UpcomingTripsQuery($travelers: [String]!) {
  allTrips(travelers: $travelers) {
    edges {
      node {
        id,
        tripName,
      }
    }
  }
}
`;

@graphql(UpcomingTripsQuery)
class UpcomingTrips extends React.Component {
  static propTypes = {
    data: PropTypes.shape().isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      foo: 'bar',
    };
  }

  content = () => {
    if (this.props.data.loading) {
      return <div>Loading…</div>;
    }

    const { data: { allTrips: { edges: trips } } } = this.props;

    return (<div>
      <ul>
        {trips.map(({ node: { id, tripName } }) => <li key={id}><Link to={`/trips/${id}/`} target='_blank'>{tripName}</Link></li>)}
      </ul>
    </div>);
  }

  render() {
    return (<div>
      <h2>Upcoming trips for travelers:</h2>
      {this.content()}
    </div>);
  }
}

export default UpcomingTrips;



// WEBPACK FOOTER //
// /src/components/Inquiry/UpcomingTrips.js